/**
 * @module utilities
 */

/**
 * Runs a callback function after the DOM has finished loading
 * @param {genericCallback} [callback] - contains code to be executed after
 */
export function docReady(callback) {
  if (document.readyState !== 'loading') {
    callback()
  } else {
    document.addEventListener('DOMContentLoaded', callback)
  }
}
